import { TypeBody1, TypeH2 } from "../../atoms/fonts/Types";
import { StandarButton } from "../../atoms/util/buttons/Buttons";
import {
	IconAndroid,
	IconApple,
	IconArrowRight,
	IconBox,
	IconDocument,
	IconHandshake,
	IconTarget,
} from "../../atoms/icons/Icons";
import { useT } from "../../../i18n/LanguageContext";
import { SellarisMockup } from "./SellarisMockup";
import "./SellarisContent.css";

const FEATURE_ICONS = {
	opportunities: IconTarget,
	proposals: IconDocument,
	agreements: IconHandshake,
	skus: IconBox,
};

export function SellarisContent() {
	const { t } = useT();
	const features = t("sellaris.features");

	return (
		<div className="sellarisContent">
			<span className="sellarisContent_watermark" aria-hidden="true">
				{t("sellaris.title")}
			</span>

			<div className="sellarisContent_grid">
				<div className="sellarisContent_text">
					<span className="-eyebrow sellarisContent_eyebrow" data-reveal="rise">{t("sellaris.eyebrow")}</span>

					<TypeH2 className="sellarisContent_title">
						<span data-reveal="tide" style={{ "--d": 1 }}>{t("sellaris.title")}</span>
					</TypeH2>

					<div data-reveal="rise" style={{ "--d": 2 }}>
					<TypeBody1 className="sellarisContent_tagline">{t("sellaris.tagline")}</TypeBody1>
					<TypeBody1 className="sellarisContent_body">{t("sellaris.body")}</TypeBody1>
					</div>

					<ul className="sellarisContent_features">
						{Array.isArray(features) &&
							features.map((feat, i) => {
								const Icon = FEATURE_ICONS[feat.key] || IconTarget;
								return (
									<li key={feat.key} className="sellarisFeature" data-reveal="chart" style={{ "--d": i + 3 }}>
										<span className="sellarisFeature_iconWrap" aria-hidden="true">
											<Icon />
										</span>
										<span className="sellarisFeature_text">
											<span className="sellarisFeature_title">{feat.title}</span>
											<span className="sellarisFeature_body">{feat.body}</span>
										</span>
									</li>
								);
							})}
					</ul>

					<div className="sellarisContent_platforms">
						<span className="sellarisPlatform">
							<IconApple />
							<span>iOS</span>
						</span>
						<span className="sellarisPlatform">
							<IconAndroid />
							<span>Android</span>
						</span>
						<span className="sellarisPlatform_label">{t("sellaris.mobileLabel")}</span>
					</div>

					<div className="sellarisContent_cta">
						<StandarButton
							variant={3}
							label={t("sellaris.cta")}
							icon={<IconArrowRight />}
							href="#contact"
						/>
					</div>
				</div>

				<div className="sellarisContent_mockupWrap" data-reveal="rise" style={{ "--d": 2 }}>
					<SellarisMockup />
				</div>
			</div>
		</div>
	);
}
